import React from 'react';
import {AccordionContainerStyled} from "../../../styled/Accordion";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import {useTheme} from "../Theme/ThemeContext";
import InsiderConnectHandler from "../JobConnection/InsiderConnectHandler";
import CompanyHandler from "../JobConnection/CompanyHandler";
import ResumePricing from "../../Pricing/ResumePricing";
import { ButtonThin } from '../../UI/Buttons/Buttons.js';
import { IoIosUnlock } from "react-icons/io";

const Accordion = ({
    loading,
    data,
    subbedForInsight,
    open,           // controlled open state
    onToggle,       // controlled toggle handler
    job,            // pass job details for insider curation
}) => {
    const [pricingOpen, setPricingOpen] = React.useState(false);
    const {themeName} = useTheme();

    const handleToggle = () => {
        if (onToggle) onToggle();
    };

    return (
        <>
            <AccordionContainerStyled onClick={handleToggle} theme={themeName}>
                {data.title}
                {open ? <FaAngleUp /> : <FaAngleDown />}
            </AccordionContainerStyled>
            {!subbedForInsight ? (
                <div>
                    <p>Upgrade your plan to Per Month to enjoy unlimited deep insights</p>
                    <br />
                    <ButtonThin onClick={() => setPricingOpen(true)} width={'120px'} height='30px' color='#EE7B1C'>
                        unlock now &nbsp; <IoIosUnlock />
                    </ButtonThin>
                </div>
            ) : (
                <>
                    {open && data.title === "Insider Connect" && <InsiderConnectHandler loading={loading} data={data.items} job={job} />}
                    {open && data.title === "Company Insights" && <CompanyHandler loading={loading} data={data.items} />}
                </>
            )}

            {pricingOpen && (
                <ResumePricing open={pricingOpen} closePricing={() => setPricingOpen(false)} />
            )}
        </>
    )
}

export default Accordion